import { useIntl } from "react-intl";
function useNumberFormatter() {
  const { formatNumber: intlFormatNumber } = useIntl();
  function formatNumber(value, options) {
    return value !== void 0 && value !== null && !isNaN(value) ? intlFormatNumber(value, options) : null;
  }
  return { formatNumber };
}
export {
  useNumberFormatter
};
//# sourceMappingURL=number.js.map
